// Imports das sagas OFX
import watchUploadOfx from './saga/extrato/uploadExtratoOfx';
import watchNewFilterExtratosOfx from './saga/extrato/newFilterExtratosOFX';
import watchNewFilterNextPageExtratosOFX from './saga/extrato/newFilterNextPageExtratosOFX';

// Imports das sagas de Conciliação Bancária
import watchNewFilterConciliacaoBancaria from './saga/newFilterConciliacaoBancaria';
import watchNewFilterNextPageConciliacaoBancaria from './saga/newFilterNextPageConciliacaoBancaria';

import watchConciliacaoIgnorarTransaction from './saga/ignorar';
import watchConciliacaoRestaurarTransaction from './saga/restaurar';
import { watchConciliarTransacoes } from './saga/conciliar';
import { watchDesconciliarTransacao } from './saga/desconciliar';
import watchNewFilterLancamentosBanco from './saga/buscarLancamentos/newFilterLancamentosBanco';
import watchNewFilterNextPageLancamentosBanco from './saga/buscarLancamentos/newFilterNextPageLancamentosBanco';
import watchNewFilterContasPagar from './saga/buscarLancamentos/newFilterContasPagar';
import watchNewFilterNextPageContasPagar from './saga/buscarLancamentos/newFilterNextPageContasPagar';
import watchNewFilterContasReceber from './saga/buscarLancamentos/newFilterContasReceber';
import watchNewFilterNextPageContasReceber from './saga/buscarLancamentos/newFilterNextPageContasReceber';
import watchNewFilterContasRecorrentes from './saga/buscarLancamentos/newFilterContasRecorrentes';
import watchNewFilterNextPageContasRecorrentes from './saga/buscarLancamentos/newFilterNextPageContasRecorrentes';
import watchGerarContaAgoraConciliacao from './saga/buscarLancamentos/gerarContaAgoraConciliacao';
import watchBuscarResumoConciliacao from './saga/buscarResumoConciliacao';

export const conciliacaoBancariaSaga = [
    // OFX
    watchUploadOfx(),
    watchNewFilterExtratosOfx(),
    watchNewFilterNextPageExtratosOFX(),
    // Conciliação Bancária
    watchNewFilterConciliacaoBancaria(),
    watchNewFilterNextPageConciliacaoBancaria(),

    watchConciliacaoIgnorarTransaction(),
    watchConciliacaoRestaurarTransaction(),
    watchConciliarTransacoes(),
    watchDesconciliarTransacao(),

    // Buscar Lançamentos
    watchNewFilterLancamentosBanco(),
    watchNewFilterNextPageLancamentosBanco(),
    watchNewFilterContasPagar(),
    watchNewFilterNextPageContasPagar(),
    watchNewFilterContasReceber(),
    watchNewFilterNextPageContasReceber(),
    watchNewFilterContasRecorrentes(),
    watchNewFilterNextPageContasRecorrentes(),
    watchGerarContaAgoraConciliacao(),
    watchBuscarResumoConciliacao(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';

// Export do reducer para modal buscar lançamentos (compatibilidade)
export { default as buscarLancamentosReducer } from './buscarLancamentosReducer';